import { useState } from "react"
import { CurrentType } from "../../../enum/CurrentType"
import { ServiceStepsLayout } from "./ServiceStepsLayout"
import { useLocation } from "react-router-dom"


export const EditService = () => {
    const [currentType, setCurrentType] = useState<CurrentType>(CurrentType.EDIT)
    const { search } = useLocation();
    const queryParams = new URLSearchParams(search)
    const primaryKey = queryParams?.get('id') ?? 0;

    return (
        <ServiceStepsLayout
            currentType={currentType}
            setCurrentType={(value) => setCurrentType(value)}
            _primaryKey={Number(primaryKey)}
        />
    )
}